import type { CustomCellEditorProps } from '@ag-grid-community/react';
import Switch from '@mui/material/Switch';

export function TableSwitch({
  value,
  onValueChange,
}: CustomCellEditorProps<unknown, boolean>) {
  return (
    <Switch
      autoFocus
      checked={!!value}
      onChange={(event) => onValueChange(event.target.checked)}
    />
  );
}
